import { Action } from "redux";
import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as types from "./actionTypes";

import { beginAjaxCall } from "./ajaxActions";

import { DataService } from "../data/DataService";

import { ISelectEventsFromOtherCalendarsState, IServer, IServerCalendarPages } from "../classes/state";

const dataService = new DataService();

export function setOpenSelectEventsFromOtherCalendarsModal(open: boolean) {
  return (dispatch) => {
    dispatch(setOpenSelectEventsFromOtherCalendarsModalAction(open));
  };
}

export function requestServersForCalendar(portletInstanceId: number, calendarId: number) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.serversForCalendar(portletInstanceId, calendarId).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      dispatch(requestServersForCalendarSuccess(response));

    }); // .catch((error) => {
    // toastr.error(error); TO DO Add some logging that event requets failed here?
    // throw error;
    // });
  };
}

export function updateServersSitesPagesAndCalendars(servers: IServer[]) {
  return (dispatch) => {
    dispatch(updateServersSitesPagesAndCalendarsAction(servers));
  };
}

export function updateCheckedNodeItemIds(checkedNodeItemIds: string[]) {
  return (dispatch) => {
    dispatch(updateCheckedNodeItemIdsAction(checkedNodeItemIds));
  };
}

export function updateCheckedNodeCalendarIds(checkedNodeCalendarIds: string[]) {
  return (dispatch) => {
    dispatch(updateCheckedNodeCalendarIdsAction(checkedNodeCalendarIds));
  };
}

export function updateExpandedNodeItemIds(expandedNodeItemIds: string[]) {
  return (dispatch) => {
    dispatch(updateExpandedNodeItemIdsAction(expandedNodeItemIds));
  };
}

export function updateCurrentPageNumber(pageNumber: number) {
  return (dispatch) => {
    dispatch(updateCurrentPageNumberAction(pageNumber));
  };
}

// Actual action creators:

const actionCreator = actionCreatorFactory();

export const setOpenSelectEventsFromOtherCalendarsModalAction = actionCreator<boolean>(types.SET_OPEN_SELECT_EVENTS_FROM_OTHER_CALENDARS_MODAL);
export const requestServersForCalendarSuccess = actionCreator<ISelectEventsFromOtherCalendarsState>(types.REQUEST_SERVERS_FOR_CALENDAR_SUCCESS);

export const updateServersSitesPagesAndCalendarsAction = actionCreator<IServer[]>(types.UPDATE_SERVERS_SITES_PAGES_AND_CALENDARS);
export const updateCheckedNodeItemIdsAction = actionCreator<string[]>(types.UPDATE_CHECKED_NODE_ITEM_IDS);
export const updateCheckedNodeCalendarIdsAction = actionCreator<string[]>(types.UPDATE_CHECKED_NODE_CALENDAR_IDS);
export const updateExpandedNodeItemIdsAction = actionCreator<string[]>(types.UPDATE_EXPANDED_NODE_ITEM_IDS);

export const updateCurrentPageNumberAction = actionCreator<number>(types.UPDATE_SELECT_EVENTS_PAGER_PAGE_NUMBER);
